import { DealerState } from '@appTypes/DealerState';
import CarFaxLogo from '@assets/svgs/logo-carfax.svg';
import { useUserProfileCarfax } from '@hooks/header/UseUserProfileCarfax';
import { useCheckDevice } from '@hooks/UseCheckDevice';
import { AppState } from '@store/AppState';
import { theme } from '@styles/theme';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ColumnWrapper, RowDivider } from '../UserProfileStyles';

const UserProfileCarFax: FC = () => {
  const { loginCarFax, logOutCarfax } = useUserProfileCarfax();
  const { isLoggedIntoCarFax } = useSelector<AppState, DealerState>((state) => state.dealer);
  const { isMobileDevice } = useCheckDevice();

  return (
    <RowDivider
      data-testid='userProfileCarFax-row'
      borderColor={isMobileDevice ? theme.palette.backgroundGray : theme.palette.lightGreySix}
    >
      <ColumnWrapper width={isMobileDevice ? '100' : '17'}>
        <CarfaxWrapper marginTopBottom='20' marginBottom={isMobileDevice ? '0' : '20'}>
          <CarfaxImageWrapper />
        </CarfaxWrapper>
      </ColumnWrapper>
      <ColumnWrapper width={isMobileDevice ? '100' : '83'}>
        <CarfaxWrapper marginTopBottom='17' marginTop={isMobileDevice ? '5' : '17'}>
          {isLoggedIntoCarFax && (
            <i className='carfax-logged-in am-icon am-icon-check-circle green' />
          )}
          {isLoggedIntoCarFax && <span className='logged-in green'>Logged In &nbsp;</span>}
          {!isLoggedIntoCarFax && (
            <TextWrapper isMobileDevice={isMobileDevice}>
              <a onClick={() => loginCarFax()}>Log in</a>
              &nbsp;to CARFAX with your email and password. You will be asked to save your
              credentials.
            </TextWrapper>
          )}
          {isLoggedIntoCarFax && (
            <span className='logout-link'>
              <a onClick={logOutCarfax}>Logout</a>
            </span>
          )}
        </CarfaxWrapper>
      </ColumnWrapper>
    </RowDivider>
  );
};

export default UserProfileCarFax;
type CarfaxWrapperProps = {
  marginTopBottom: string;
  marginBottom?: string;
  marginTop?: string;
};

type TextWrapperProps = {
  isMobileDevice: boolean;
};

const CarfaxWrapper = styled.div<CarfaxWrapperProps>`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: ${(props) => props.marginTopBottom}px 0;
  margin-bottom: ${(props) => props.marginBottom}px;
  margin-top: ${(props) => props.marginTop}px;
`;

const CarfaxImageWrapper = styled.img.attrs({
  src: CarFaxLogo,
})`
  width: 90px;
  height: 19px;
  margin-right: 14px;
  display: inline-block;
  margin: 0 5px 3px 0;
  clear: none;
  text-indent: -9999px;
  vertical-align: middle;
`;

const TextWrapper = styled.span<TextWrapperProps>`
  position: relative;
  left: ${(props) => (props.isMobileDevice ? '0' : '10')}px;
  a {
    color: #337ab7 !important;
    text-decoration: none;
  }
`;
